module.exports = __webpack_public_path__ + "img/IMG_7249.87a05618.webp";